import React from "react";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import { Colors } from "../../Styles/Colors";
import { getScreenAccess } from "../../Utility/Services/RoleAccessService";

export function ClickableCard({
  isSelected,
  icon,
  label,
  labelTwo,
  onClick,
  alt,
  testID,
  disable,
  width,
  height,
}) {
  const iconSrc = icon?.default ?? icon;
  return (
    <Button
      emed_tid={testID}
      className="eMed_Click_card_hover"
      disabled={disable}
      sx={{ textTransform: "none" }}
    >
      <Card
        elevation={3}
        onClick={() => onClick?.()}
        className="eMed_Clickable_card"
        sx={{ backgroundColor: isSelected ? Colors.ThemeColor : "" }}
      >
        <div className="eMed_Clickable_card_inner" style={{ color: isSelected ? "white" : "" }}>
          <div>
            <img
              style={{ width: width || "2vw", height: height || "2vw", display: "block" }}
              src={iconSrc}
              alt={alt || label}
            />
          </div>
          <div className="eMed_Clickable_label">
            {label}
          </div>
          {labelTwo ? (
            <div className="eMed_Clickable_label">
              {labelTwo}
            </div>
          ) : null}
        </div>
      </Card>
    </Button>
  );
}

/**
 * Returns view/edit access for a screen tab from Scrren_access (same structure as AddRoleAccess).
 * MenuName = screen title (e.g. "Settings"), TabName = main_tab title (e.g. "Service Master").
 * For new Settings structure there are no sub_tabs; use Type "Tab" and TabName only.
 */
export function CheckAccessFunc(Module, MenuName, TabName = null, SubTabName = null, Type) {
  const access = getScreenAccess();
  if (!access) return { viewAccess: true, editAccess: true, title: TabName || "" };
  const screen = access.find((s) => s.title === MenuName);
  if (!screen) return { viewAccess: true, editAccess: true, title: TabName || "" };
  if (!TabName) return { viewAccess: !!screen.viewAccess, editAccess: !!screen.editAccess, title: "" };
  const tab = screen.main_tabs?.find((t) => t.title === TabName);
  if (!tab) return { viewAccess: true, editAccess: true, title: TabName };
  if (Type === "SubTab" && SubTabName && tab.sub_tabs?.length) {
    const sub = tab.sub_tabs.find((st) => st.title === SubTabName);
    return sub ? { viewAccess: !!sub.viewAccess, editAccess: !!sub.editAccess, title: SubTabName } : { viewAccess: !!tab.viewAccess, editAccess: !!tab.editAccess, title: TabName };
  }
  return { viewAccess: !!tab.viewAccess, editAccess: !!tab.editAccess, title: TabName };
}
